import styled from "styled-components";
import { COLORS } from "../../../constants";

const PageTitle = styled.h1`
  color: ${COLORS.WHITE};
  text-align: center;
  align-self: stretch;
  /* H1 */
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export default PageTitle;